import {Component, Inject, OnInit} from '@angular/core';
import {ICellRendererParams} from '@ag-grid-community/core';
import {ReportTableStore} from '../../store/report/report-table.store';

@Component({
  selector: 'app-column-metric',
  templateUrl: './cell-metric.component.html',
  styleUrls: ['./cell-metric.component.scss']
})
export class CellMetricComponent implements OnInit {

  constructor(
    @Inject('agGridParams') public readonly agGridParams: ICellRendererParams,
    private readonly _reportTableStore: ReportTableStore
  ) {}

  ngOnInit(): void {}

  public openTrendsDialog(): void {
    this._reportTableStore.trendsDialog({
      agGridParams: this.agGridParams
    });
  }

}
